import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_get_vendorlot_by_lookupcode_and_materialIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { materialId: number, vendorLookupcode: string }): 
  Promise<{ result: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialId)) {
      $missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil($inParams.vendorLookupcode)) {
      $missingRequiredInParams.push('\'vendorLookupcode\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { materialId: number, vendorLookupcode: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialId)) {
      $missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil($inParams.vendorLookupcode)) {
      $missingRequiredInParams.push('\'vendorLookupcode\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { materialId: number, vendorLookupcode: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialId)) {
      $missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil($inParams.vendorLookupcode)) {
      $missingRequiredInParams.push('\'vendorLookupcode\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      materialId: number, vendorLookupcode: string    }) {
        if(isNil($inParams.materialId)) {
          return true; 
        }
        if(isNil($inParams.vendorLookupcode)) {
          return true; 
        }
      return false;
    }
}
